/**
 * Venice AI Configuration
 * 
 * Venice AI provides uncensored LLM access via OpenAI-compatible API
 * Models are prefixed with "venice/" to route through VeniceProvider
 */

export const VENICE_MODELS = {
  LLAMA_3_3_70B: 'venice/llama-3.3-70b',
  UNCENSORED: 'venice/llama-3.3-70b',  // Alias for the main uncensored model
};

export const DEFAULT_VENICE_MODEL = VENICE_MODELS.LLAMA_3_3_70B;

export const AVAILABLE_VENICE_MODELS = [
  { 
    id: VENICE_MODELS.UNCENSORED, 
    name: 'Venice Uncensored (Llama 3.3 70B)', 
    provider: 'venice',
    family: 'llama-3.3'
  },
];

/**
 * Check if a model ID is a Venice model
 */
export function isVeniceModel(modelId: string): boolean {
  return modelId.startsWith('venice/');
}

/**
 * Get Venice model name without prefix
 */
export function getVeniceModelName(modelId: string): string {
  return modelId.replace('venice/', '');
}

